module.exports = __webpack_public_path__ + "img/portraits_11_V.71420baa.webp";